export default {
    App: null,
    Route: null,

    init(app) {
        this.App = app
        this.Route = app.$route
    },
    getModalPanels() {
        return this.App.$children[0].$refs.modalPanels
    },
    getPath() {
        return this.Route.path
    }
}
